import { render, staticRenderFns } from "./ZenMahjong.vue?vue&type=template&id=80661870"
import script from "./ZenMahjong.vue?vue&type=script&lang=js"
export * from "./ZenMahjong.vue?vue&type=script&lang=js"
import style0 from "./ZenMahjong.vue?vue&type=style&index=0&id=80661870&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports